import { connect } from 'react-redux';
import { _DARK_LOGO } from '~/utils/config';
import React, { useState, useEffect } from 'react';
import LogoComponent from '../../presentations/logo';
import pave_logo from '~/themes/default/assets/pave_logo_white_rvb.png';

function PaveLogo(props) {
  const { logoType, className, style, themeReducer, deviceLocale } = props;

  const { logo_primary, logo_secondary, logo, logo_light_primary, logo_light } =
    !!themeReducer && themeReducer;
  const [url, setUrl] = useState(null);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    // console.log('logoType: ', {
    //   logoType,
    //   logo_primary,
    //   logo_secondary,
    //   logo,
    //   logo_light_primary,
    //   logo_light,
    // });
    if (logoType === _DARK_LOGO) {
      setUrl(logo_primary);
    } else {
      if (!logo_light_primary) {
        // console.log('logoType: 1.0 ', logoType);
        logo ? setUrl(logo) : setUrl(logo_light ? logo_light : logo_secondary);
      } else {
        if (logo_light_primary) {
          // console.log('logoType: 2.0 ', logoType);
          logo_light ? setUrl(logo_light) : setUrl(pave_logo);
          return;
        }

        logo_secondary
          ? setUrl(logo_light)
          : logo
          ? setUrl(logo)
          : setUrl(pave_logo);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoType]);

  useEffect(() => {
    const deviceLangs = document.getElementById('deviceLangs');

    deviceLangs.addEventListener('click', function (e) {
      setIsShow((state) => !state);
    });
  }, []);

  return (
    <div id="deviceLangs" style={{ color: 'white', textAlign: 'center' }}>
      {!!url && <LogoComponent url={url} className={className} style={style} />}
      <span style={{ display: isShow ? 'block' : 'none' }}>{deviceLocale}</span>
    </div>
  );
}
const mapStateToProps = (state) => ({
  themeReducer: state.themeReducer.userCustom,
  deviceLocale: state.languageProviderReducer.deviceLangs,
});

export default connect(mapStateToProps, null)(React.memo(PaveLogo));
